import * as React from "react";
import { Redirect } from "react-router";

import reducer, { logoutFlow as saga } from "@mochi/misc/auth/logout/redux";
import { injectSaga } from "@mochi/core";
import { injectReducer } from "@mochi/misc";

export function Logout({ logout, logOutStatus }) {
  React.useEffect(() => {
    injectReducer("logoutApiToken", reducer);
    injectSaga("logoutSaga", saga);
    logout();
  }, [logout]);
  return logOutStatus ? (
    <Redirect to="/login" />
  ) : (
    <div>Log in successful...</div>
  );
}
